import { createFileRoute } from '@tanstack/react-router';

import { PreGameRoutineStep } from '@/features/onboarding/components/steps/lf/preGameRoutineStep';

export const Route = createFileRoute(
  '/_protected/onboarding/_steps/pre-game-routine',
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <PreGameRoutineStep />;
}
